import { supabase } from '@/integrations/supabase/client';

export async function validateAmbassadorInviteCode(code: string): Promise<boolean> {
  const normalizedCode = code.trim().toUpperCase();
  if (!normalizedCode) return false;
  const { data, error } = await supabase.rpc('validate_ambassador_invite_code', { _code: normalizedCode });
  if (error) throw error;
  return data === true;
}